import React from 'react'
import { DotMark24 } from '@carbon/icons-react'

function Warning({ value }) {
  return (
    <div className='warning'>
      <span className={`status-icon ${value ? 'warning' : 'not-warning'}`}>
        <DotMark24 />
      </span>
    </div>
  )
}

export default Warning
